import clsx from 'clsx';
import { LocalImage } from '@shared/widgets';

interface CardImageProps {
  className?: string;
  dark?: boolean;
  image: string | Blob;
  number: string;
  validThru: string | null;
  cardHolder: string;
}

export const CardImage = (props: CardImageProps) => {
  return (
    <div
      className={clsx(
        'relative font-[600] text-[12px] tracking-[0.3px] uppercase text-[#000] text-shadow-[0_1px_0_#fff] ',
        props.dark && 'text-[#c0c0c0] text-shadow-[0_1px_0_#000]',
        props.className,
      )}
    >
      <LocalImage className='rounded-[4px] shadow-none block w-full' src={props.image} />

      <p className='absolute m-0 leading-[1.2] text-[1.333em] tracking-[1.5px] top-[58%] left-[6%]'>{props.number}</p>
      <p
        className="absolute top-[71.5%] left-[38%] m-0 leading-[1.2]
    before:content-['valid_thru'] before:absolute before:-left-[85%] before:w-0 
    before:font-medium before:text-[0.5em] before:tracking-[0.1px] before:leading-[1.3]
    after:absolute after:-left-[23%] after:top-[25%] after:w-0 
    after:border-t-[2.6px] after:border-l-[3.7px] after:border-b-[2.6px] 
    after:border-transparent after:border-l-[#5b5b5b]"
      >
        {props.validThru}
      </p>
      <p className='absolute m-0 leading-[1.2] top-[82%] left-[6%]'>{props.cardHolder}</p>
    </div>
  );
};
